import React, { Component } from "react";
import posed from "react-pose";
import SplitText from "react-pose-text";

const NavbarMotion = posed.nav({
  shown: {
    y: "0%"
    //staggerChildren: 100
  },
  hidden: {
    y: "-100%"
  }
});

const charPoses = {
  exit: { y: 20, opacity: 0 },
  enter: {
    y: 0,
    opacity: 1,
    transition: ({ charInWordIndex }) => ({
      type: "spring",
      delay: charInWordIndex * 60,
      stiffness: 500 + charInWordIndex * 150,
      damping: 10 - charInWordIndex * 1
    })
  }
};

class Navbar extends Component {
  state = {
    on: false
  };

  componentDidMount() {
    setTimeout(this.slideIn, 200);
  }

  slideIn = () => {
    this.setState({ on: !this.state.on });
  };

  render() {
    return (
      <>
        <header className="header">
          <NavbarMotion
            pose={this.state.on ? "shown" : "hidden"}
            className="navbar navbar-expand-lg fixed-top"
            style={{
              boxShadow: "0 0.5rem 2rem rgba(0,0,0,0.1)",
              transition: "background 0.2s ease-out 0s"
            }}
          >
            <div className="container">
              <a className="navbar-brand" href="#">
                <img src="img/db.png" width={40} />
              </a>
              <button
                className="navbar-toggler navbar-toggler-right"
                type="button"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <i className="fas fa-bars" />
              </button>
              <div
                className="collapse navbar-collapse"
                id="navbarSupportedContent"
              >
                <ul className="navbar-nav ml-auto">
                  <li className="nav-item">
                    <a className="nav-link link-scroll active" href="#hero">
                      <SplitText
                        initialPose="exit"
                        pose="enter"
                        charPoses={charPoses}
                      >
                        Home
                      </SplitText>{" "}
                      <span className="sr-only">(current)</span>
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link link-scroll" href="#about">
                      <SplitText
                        initialPose="exit"
                        pose="enter"
                        charPoses={charPoses}
                      >
                        About
                      </SplitText>
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link link-scroll" href="#expertise">
                      <SplitText
                        initialPose="exit"
                        pose="enter"
                        charPoses={charPoses}
                      >
                        Portfolio
                      </SplitText>
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link link-scroll" href="#contact">
                      <SplitText
                        initialPose="exit"
                        pose="enter"
                        charPoses={charPoses}
                      >
                        Contact
                      </SplitText>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </NavbarMotion>
        </header>
      </>
    );
  }
}

export default Navbar;
